let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lcqzB")).then(() => parcelRequire('8Y00B'));